/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Translations_Imported_SuccessInputs */



/**
* | output |
* | --- |
* | "{count} translations imported successfully" |
*
* @param {Translations_Imported_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translations_imported_success = /** @type {((inputs: Translations_Imported_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translations_Imported_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} traductions importées avec succès`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Übersetzungen erfolgreich importiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} traduzioni importate con successo`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} переводов успешно импортировано`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} traducciones importadas exitosamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 个翻译已成功导入`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count}件の翻訳が正常にインポートされました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} अनुवाद सफलतापूर्वक आयात हो गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} traduções importadas com sucesso`)
	return /** @type {LocalizedString} */ (`${i?.count} translations imported successfully`)
});